<template>
	<div class="outer">
		<div class="middle">
			<div class="inner text-center">
				<font-awesome-icon class="active-color " icon="solar-panel" size="4x" />
				<p class="no-locs-text p-t-xl">
					You have not configured any plants yet
				</p>
				<p class="no-locs-text">
					Click on
					<router-link class="active-color" :to="{ name: 'add-new' }"
						>Add PV plant</router-link
					>
					in the top bar menu
				</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "NoLocations"
};
</script>

<style>
#home-import-text {
	font-size: 16px;
	line-height: 1.5;
	margin: 15px 0 0;
}
.outer {
	display: table;
	position: absolute;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
}

.middle {
	display: table-cell;
	vertical-align: middle;
}

.inner {
	margin-left: auto;
	margin-right: auto;
	width: 95%;
}
.no-locs-text {
	font-size: 22px;
	line-height: 1.5;
	margin: 0;
}
</style>
